import React, { useState } from "react";
import "./FormBodyContactar.scss"
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

// Components //
import FormGroupAceleradora from "../form-group-aceleradora/FormGroupAceleradora";
import FormContactarGrupalList from "../form-contactar-grupal-list/FormContactarGrupalList";

interface IBodyFormContactar {
    titulosFormulario: Array<any>;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    inputDisabled: string[];
    isDisabledButton?: boolean;
    handleBigCancelButton?: any;
    children?: any;
    listSelectedTalents: any;
    setListSelectedTalents: any;
    messageTalent: any;
    setActivateToast: any;
}

const FormBodyContactar = (props: IBodyFormContactar) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const { window } = useBrowserMode();
    const [isDisabledForProhibited, setIsDisabledForProhibited] = useState<boolean>(false);

    const{
        titulosFormulario,
        setInputValue,
        formValues,
        handleSubmitForm,
        inputDisabled,
        isDisabledButton,
        handleBigCancelButton,
        children,
        listSelectedTalents,
        setListSelectedTalents,
        messageTalent,
        setActivateToast
    }=props;

    return (
        <div className="m-form-body-contactar">
            {/* Renderiza los talentos seleccionados cuando es el formulario grupal*/}
            {window.location.pathname.includes("grupal") && (
                <div className="m-form-list-grupal">
                    <FormContactarGrupalList
                        listSelectedTalents={listSelectedTalents}
                        setListSelectedTalents={setListSelectedTalents}
                        setIsDisabledForProhibited={setIsDisabledForProhibited}
                        messageTalent={messageTalent}
                        setActivateToast={setActivateToast}
                    />
                </div>
            )}
            {/* Crea grupo el cual contiene secciones y en estas los campos/inputs. */}
            <FormGroupAceleradora
                titulosFormulario={titulosFormulario}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                endIndex={titulosFormulario.length}
                setInputValue={setInputValue}
                formValues={formValues}
                handleSubmitForm={handleSubmitForm}
                inputDisabled={inputDisabled}
                isDisabledButton={!!isDisabledButton || !!isDisabledForProhibited}
                flagGTM={
                        window.location.pathname.includes("grupal")
                        ? "_encontrar_talento_enviar_solicitud_grupal" 
                        : "_encontrar_talento_enviar_solicitud_individual"
                        }
                handleBigCancelButton={handleBigCancelButton}
            />
            {children}
        </div>
    );
};

export default FormBodyContactar;